import * as Yup from 'yup'
import i18next from 'i18next';
import { createSchema } from '../framework/entity/yup';
import { ServiceDescriptor } from '../models/ServiceDescriptor';

const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const defaultSchema = () => createSchema<ServiceDescriptor>([
    [x => x.groupDescriptorId, Yup.number().required(i18next.t('Il gruppo di competenza è obbligatorio'))],
    [x => x.url, Yup.string().required(i18next.t('L\'url è obbligatorio'))],
    [x => x.urlDescription, Yup.string().required(i18next.t('La descrizione url è obbligatoria'))],
    [x => x.livello, Yup.string().required(i18next.t('Il Livello è obbligatorio'))],
    [x => x.sezione, Yup.string().required(i18next.t('La sezione è obbligatoria'))],
    //[x => x.ambiente, Yup.string().required(i18next.t('L\'ambiente è obbligatorio'))], non più obbligatorio ambiente
    [x => x.tipoAppl, Yup.string().required(i18next.t('Il tipo appl. è obbligatorio'))],
    [x => x.guid, Yup.string().nullable().test('guid', i18next.t('Guid non valido'), (value, context) => {
        
        let item = context.parent as ServiceDescriptor;
        if (!item || !value) {
            return true;
        }
       
        console.debug('guid value', value)
        const regexp = new RegExp(guidPattern)
        let result = regexp.test(value);        
        console.debug('guid result test', result)
        // if (value === '<p></p>\n') {
        //     return false;
        // }
        return result;
    })],
])

export function getSdValidationSchema() {

    let schema = defaultSchema();
    
    //     if (personRequiredField.custom) {
    //         let list: string[] = personRequiredField.fields ? JSON.parse(personRequiredField.fields) : [];
    //         schema = schema.concat(dynamicSchema(list));
    //     }      

    return schema;
}
